import React from "react";
import CorpoClinicoSteps from "./steps/CorpoClinicoSteps";
import { CorpoClinicoStoreProvider } from '../../../context/CorpoClinicoContext';

export default function CorpoClinico() {

    return (
        <CorpoClinicoStoreProvider>
            <CorpoClinicoSteps />
        </CorpoClinicoStoreProvider>
    )

}